import executeQuery from "#lib/db"
import type { Recipe } from "#types"

export const getRecipes = async ({ categoryID }: { categoryID: string }): Promise<Recipe[]> => {
	const list = await executeQuery({
		query: `
			select
				*,
				greatest(
					recipes.dateCreated,
					recipes.dateModified,
					(select
						max(greatest(
							recipe_ingredients.dateCreated,
							recipe_ingredients.dateModified
						))
						from recipe_ingredients
						where recipe_ingredients.recipeID = recipes.recipeID
					),
					(select
						max(greatest(
							recipe_instructions.dateCreated,
							recipe_instructions.dateModified
						))
						from recipe_instructions
						where recipe_instructions.recipeID = recipes.recipeID
					)
				) as lastUpdated
			from
				recipes
			where
				recipes.categoryID = ?
		`,
		values: categoryID,
	})
	return list
}
